import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Box, Container, Tab } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import Offer from './Offer'
import MyOffer from './MyOffer'
import Traning from './Traning'
import MyTraning from './MyTraning'

export default function Opportunities() {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [value, setValue] = React.useState('1')

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  return (
    <Container maxWidth="xl">
      <Box sx={{ width: '100%', typography: 'body1', color: 'white' }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList
              onChange={handleChange}
              sx={{
                '.MuiTabs-flexContainer': {
                  overflow: 'auto',
                  justifyContent: 'flex-start',
                  gap: 4,
                },
              }}
            >
              <Tab sx={{ color: 'white', fontSize: 'medium' }} label={t('opportunities.tabJobOffer') /* LAP-733 (GE022) */} value="1" />
              <Tab
                sx={{ color: 'white', fontSize: 'medium' }}
                label={t('opportunities.tabMyJobOffers') /* LAP-733 (GE022) */}
                value="2"
              />
              <Tab sx={{ color: 'white', fontSize: 'medium' }} label={t('opportunities.tabTrainingOffer') /* LAP-733 (GE022) */} value="3" />
              <Tab
                sx={{ color: 'white', fontSize: 'medium' }}
                label={t('opportunities.tabMyTrainingOffers') /* LAP-733 (GE022) */}
                value="4"
              />
            </TabList>
          </Box>
          <TabPanel value="1">
            <Offer />
          </TabPanel>
          <TabPanel value="2">
            <MyOffer />
          </TabPanel>
          <TabPanel value="3">
            <Traning />
          </TabPanel>
          <TabPanel value="4">
            <MyTraning />
          </TabPanel>
        </TabContext>
      </Box>
    </Container>
  )
}
